<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/courses/{{ dataSource.parent_id }}/modules">Modules</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class=" mr-auto">
        <button mat-raised-button routerLink="/courses" class="m-1 mr-2">
          <mat-icon>arrow_back</mat-icon> Inductions
        </button>

        <button
          *ngIf="canCreate"
          mat-raised-button
          color="primary"
          (click)="onAdd()"
          class="m-1 mr-2">
          <mat-icon>add</mat-icon>
          Add Module
        </button>

        <ng-container *ngIf="canDelete">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button mat-menu-item *ngIf="canDelete" (click)="onDeleteSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Delete Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Induction Modules." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

<!--      <span class="spinner-container" *ngIf="(dataSource.loading | async)" appMarginRight></span>-->

      <form *ngIf="canView" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

      <!--button mat-raised-button (click)="export()" color="secondary"><mat-icon>import_export</mat-icon> Export</button-->
    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view induction modules.
    <span *ngIf="canCreate">You can still create new modules using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="name"
      matSortDirection="asc"
      matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row.id) : null"
            [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Module Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Date Created Column -->
      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
        <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertMedium }}</td>
      </ng-container>

      <!-- Dated Created (UTC) Column -->
      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created (UTC)</th>
        <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertUTCMedium }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="440"></th>

        <td mat-cell *matCellDef="let element">
          <button *ngIf="canView" type="button" mat-button (click)="onView(element)">
            View
          </button>

          <button *ngIf="canEdit" type="button" mat-button (click)="onEdit(element)">
            Edit
          </button>

          <button *ngIf="canView" type="button" mat-button [routerLink]="'/courses/' + dataSource.parent_id + '/modules/'+ element.id+ '/sections'">
            Sub-Sections
          </button>

          <button *ngIf="canView" type="button" mat-button [routerLink]="'/courses/' + dataSource.parent_id + '/modules/'+ element.id + '/questions'">
            Questions
          </button>

          <button *ngIf="canDelete" type="button" mat-button (click)="onRemove(element.id)">
            Delete
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
